import { useContext } from 'react';

import type { FormValues } from '#src/app/pages/petitionDetails/shared/types';

import { MobileSignFormValuesContext, MobileSignFormCallbackContext } from './context';

export type MobileSignFormContextValues = {
	mobileSignFormValues: FormValues | null;
	updateMobileSignFormValues: (values: FormValues) => void;
};

export const useMobileSignFormValues = (): MobileSignFormContextValues => {
	const mobileSignFormValues = useContext(MobileSignFormValuesContext);
	const updateMobileSignFormValues = useContext(MobileSignFormCallbackContext);

	if (mobileSignFormValues === undefined || !updateMobileSignFormValues) {
		throw new Error('MobileSignFormContext not found');
	}

	return { mobileSignFormValues, updateMobileSignFormValues };
};
